module.exports = __webpack_public_path__ + "128a26622393c8579700da59fc6899d6.svg";